import { AddMenuOrderPayload } from "shared-ui/MenuOrder/utils";
import { useSnackbar } from "apps/web/src/components/Snackbar/SnackbarContext";
import { trackEvent } from "apps/web/src/reporting/reporting";
import { KioskMealMenuPreviewFragment, useAddMenuOrderForGuestKioskMutation } from "../../../../types";
import KioskMealMenuDialog from "../Dialog/Add";
import { GuestIdentity } from "./types";

interface GuestOrderFormProps {
  open: boolean;
  onClose: () => void;
  guest: GuestIdentity;
  mealMenu: KioskMealMenuPreviewFragment;
  onOrderPlaced: (args: { orderCode: string; pickupTime: string }) => void;
  onError: () => void;
}

export const GuestOrderForm = ({ open, onClose, guest, mealMenu, onOrderPlaced, onError }: GuestOrderFormProps) => {
  const guestName = `${guest.firstName} ${guest.lastName}`;
  const { setMessage } = useSnackbar();

  const [addMenuOrderForGuest] = useAddMenuOrderForGuestKioskMutation({
    onCompleted: data => {
      trackEvent("Nutrition | Kitchen | Kiosk | Meal Order | Guest Order Placed", {
        orderId: data.addMenuOrderForGuest.menuOrder.id,
        menuId: mealMenu.id,
        guestFirstName: guest.firstName,
        guestLastName: guest.lastName,
        smsOptIn: guest.smsOptIn,
        mealType: mealMenu.mealType,
      });
      onOrderPlaced({
        orderCode: data.addMenuOrderForGuest.menuOrder.code,
        pickupTime: data.addMenuOrderForGuest.menuOrder.pickupTime,
      });
    },
    onError: () => {
      setMessage("error", "Something went wrong!");
      onError();
    },
  });

  const handleAddMenuOrder = ({ pickupTime, orderItems, logItems, isDineIn, isToGo }: AddMenuOrderPayload, mealMenuId: string) => {
    addMenuOrderForGuest({
      variables: {
        input: {
          mealMenuId,
          pickupTime,
          items: [...orderItems, ...logItems],
          guestFirstName: guest.firstName,
          guestLastName: guest.lastName,
          guestPhoneNumber: guest.phoneNumber,
          guestEmail: guest.email,
          guestSmsOptIn: guest.smsOptIn,
          isDineIn: isDineIn || false,
          isToGo: isToGo || false,
        },
      },
    });
  };

  return (
    <KioskMealMenuDialog
      viewOnly={false}
      onAddMenuOrder={handleAddMenuOrder}
      mealMenu={mealMenu}
      mealTemplate={null}
      onClose={onClose}
      open={open}
      teamId=""
      athleteId=""
      athleteName={guestName}
      avoidFoodGroupIds={[]}
      menuOrders={[]}
      athleteOrderState={{ type: "new", selectedMealMenu: mealMenu }}
      athleteOrderStateDispatch={() => {}}
      isGuestOrder
    />
  );
};
